import { Component, HostBinding, inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { generateUUID } from 'projects/processo-custom-table/src/usecase';
interface TabData {
  value: string;
  name: string;
  color: string;
}
@Component({
    selector: 'lib-add-tag-popup',
    templateUrl: './add-tag-popup.component.html',
    styleUrls: ['./add-tag-popup.component.scss'],
    standalone: false
})
export class AddTagPopupComponent {
  @HostBinding('attr.unique-id')
  uniqueId = `${generateUUID()}`;
  readonly nzModalData: any = inject(NZ_MODAL_DATA);
  popupHeaderName!: string;
  defaultTabData: any;
  constructor(private modal: NzModalRef, private fb: FormBuilder) {}
  addStatuessForm!: FormGroup;
  color: any = [
    {
      color: '#1DF1FF',
    },
    {
      color: '#56C0C6',
    },
    {
      color: '#FF1DE8',
    },
    {
      color: '#F70295',
    },
    {
      color: '#FFC01D',
    },
    {
      color: '#CF6BFF',
    },
    {
      color: '#E9FD00',
    },
    {
      color: '#FF8058',
    },
  ];
  ngOnInit(): void {
    this.defaultTabData = this.nzModalData.value;
    this.popupHeaderName = this.nzModalData?.data?.popupName;
    this.createForm();
  }

  createForm() {
    this.addStatuessForm = this.fb.group({
      statuesDetails: this.fb.array([]),
    });
    if (this.defaultTabData && this.defaultTabData.length > 0) {
      this.defaultTabData.forEach((tabData: TabData | undefined) => {
        this.statuesDetails().push(this.newStatusAddDetails(tabData));
      });
    } else {
      // this.addMore();
    }
    this.statuesDetails().push(this.newStatusAddDetails());
  }

  newStatusAddDetails(tabData: TabData = {} as TabData): FormGroup {
    const valuename = tabData.value || '';
    const fieldname = tabData.name || '';
    const color = tabData.color || '';
    return this.fb.group({
      // value: [{ value: valuename, disabled: false }, [Validators.required]],
      name: [{ value: fieldname, disabled: false }, [Validators.required]],
      color: [color],
    });
  }

  statuesDetails(): FormArray {
    return this.addStatuessForm.get('statuesDetails') as FormArray;
  }

  close() {
    this.modal.destroy();
  }
  updateColor(index: number, color: string) {
    this.statuesDetails().at(index).get('color')?.setValue(color);
  }
  confirm() {
    if (this.addStatuessForm.valid && !this.duplicateNameError) {
      let result = this.statuesDetails().controls.map((e: any, i: any) => {
        return { ...e.value };
      });
      const namesSet = new Set<string>();
      for (const { name, index } of result) {
        if (namesSet.has(name)) {
          this.duplicateNameError = true;
          this.duplicateNameIndex = index;
          return;
        } else {
          this.duplicateNameError = false;
        }
        namesSet.add(name);
      }
      this.modal.destroy(result);
    } else {
      this.statuesDetails().markAllAsTouched();
      this.statuesDetails().markAsDirty();
    }
  }

  addMore() {
    if (!this.duplicateNameError) {
      this.statuesDetails().push(this.newStatusAddDetails());
    }
  }
  removeColor(index: any) {
    const statusDetailsArray = this.addStatuessForm.get(
      'statuesDetails'
    ) as FormArray;
    const selectedStatus = statusDetailsArray.at(index);
    selectedStatus.get('color')?.setValue('');
  }
  draggedColumnIndex: any;
  dragStartColumn(i: any, e: any) {
    if (!this.duplicateNameError) {
      this.draggedColumnIndex = i;
    }
  }
  allowDrop(e: any) {
    if (!this.duplicateNameError) {
      e.preventDefault();
    }
  }
  dropColumn(i: any, e: any) {
    if (!this.duplicateNameError) {
      this.arrayMove(
        this.statuesDetails().controls,
        this.draggedColumnIndex,
        i
      );
    }
  }
  arrayMove(arr: any[], from: any, to: any) {
    if (from < 0 || from >= arr.length || to < 0 || to >= arr.length) {
      return;
    }
    const element = arr[from];
    arr.splice(from, 1);
    arr.splice(to, 0, element);
    this.draggedColumnIndex = null;
  }
  duplicateNameError: boolean = false;
  duplicateNameIndex!: number | null;
  inputFieldName(index: number, event: any) {
    let inputText = event.target.value;
    let result = this.statuesDetails().controls.map((e: any, i: any) => {
      return { ...e.value, index: i };
    });

    let isDuplicate = result?.filter((e: any) => e.name === inputText);
    if (isDuplicate.length > 1) {
      this.duplicateNameError = true;
      this.duplicateNameIndex = index;
    } else {
      this.duplicateNameError = false;
      this.duplicateNameIndex = null;
    }
  }
  checkDuplicatename() {
    const nameSet = new Set<string>();
    for (const obj of this.addStatuessForm.value.statuesDetails) {
      if (nameSet.has(obj.name)) {
        this.duplicateNameError = true;
        return false;
      } else {
        this.duplicateNameError = true;
        nameSet.add(obj.name);
      }
    }
    if (nameSet) {
      this.duplicateNameError = false;
    }
    return true;
  }
  removeStatusOption(index: number) {
    const statuesDetailsArray = this.addStatuessForm.get(
      'statuesDetails'
    ) as FormArray;
    statuesDetailsArray.removeAt(index);
  }
}
